// 使用正则表达式测试邮箱是否合法
export function isValidEmail(email: string) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  return emailPattern.test(email)
}

// Website url 验证
export function isValidURL(url: string) {
  // 去除首尾空格
  const trimmedURL = url.trim()

  // 检查中间是否有空格
  if (trimmedURL.includes(" ")) {
    return false
  }

  // 确保URL包含双斜杠格式 (http:// 或 https://)
  if (!trimmedURL.match(/^https?:\/\//)) {
    return false
  }

  try {
    const parsedURL = new URL(trimmedURL)

    return parsedURL.protocol === "http:" || parsedURL.protocol === "https:"
  } catch (error) {
    return false
  }
}

// 国际号码手机格式验证
export function checkPhoneNumberFormat(number: string) {
  if (!number) return false
  if (number && number.trim().length < 5) {
    return false
  }
  return number.split(" ")[1] !== ""
}

// E164国际电话号码验证
export function isE164PhoneNumber(input: string) {
  // 去除手机号码中的符号，不然号码校验不通过
  if (typeof input !== "string") {
    throw new TypeError(`Expected \`phone\` to be of type \`string\`, got \`${typeof input}\``)
  }
  const filterPhone = (value: string) => {
    return value.replaceAll(" ", "")
      .replaceAll("(", "")
      .replaceAll(")", "")
      .replaceAll("-", "")
  }

  return /^\+?[1-9]\d{4,14}$/.test(filterPhone(input))
}
